import React, { useState } from "react";
import AddModal from "../modal/AddModal";
import { DropdownComponent, InputComponent } from "../../../core/Forms";
import { ClipSmallIcon } from "../../../../assets/icons/Clip";
import { CloseIcon } from "../../../../assets/icons";
import { ICreateSalesData } from "../../../../@types";

interface RecurringModalProps {
  toggleRecurring: boolean;
  handleToggleRecurring: () => void;
  formData: ICreateSalesData;
  setFormData: React.Dispatch<React.SetStateAction<ICreateSalesData>>;
}

const RecurringModal: React.FC<RecurringModalProps> = ({
  toggleRecurring,
  handleToggleRecurring,
  setFormData,
  formData,
}) => {
  const repeatArr = [
    { label: "Hourly", value: "hourly" },
    { label: "Daily", value: "daily" },
    { label: "Weekly", value: "weekly" },
    { label: "Monthly", value: "monthly" },
    { label: "Yearly", value: "yearly" },
    // { label: "Custom", value: "custom" },
  ];
  const ChannelArr = [
    { label: "SMS", value: "sms" },
    { label: "Email", value: "mail" },
  ];

  // State for the "End date" input
  const [endDate, setEndDate] = useState<string | undefined>(
    formData.isReoccurringEndDate ?? undefined,
  );

  // State for the "Repeat non-stop" checkbox
  const [repeatNonStop, setRepeatNonStop] = useState(
    formData.isReoccurringEndDate == undefined &&
      formData.reoccurringGroupName !== undefined,
  );

  // State for the "Repeat" dropdown
  const [repeatOption, setRepeatOption] = useState<string | undefined>(
    formData.reoccurringGroupName ?? undefined,
  );
  const remind = () => {
    return formData.shouldSendSMS
      ? "sms"
      : formData.shouldSendEmail
        ? "mail"
        : undefined;
  };
  // State for the "Reminder Channel" dropdown
  const [reminderChannel, setReminderChannel] = useState<string | undefined>(
    remind() ?? undefined,
  );

  // Handler for date input change
  const handleEndDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setEndDate(e.target.value);
  };

  // Handler when the Continue button is clicked
  const handleContinue = () => {
    setFormData((prev) => ({
      ...prev,
      isReoccurringEndDate: repeatNonStop ? undefined : endDate,
      reoccurringGroupName: repeatOption,
      shouldSendEmail: reminderChannel == "mail" ? true : false,
      shouldSendSMS: reminderChannel == "sms" ? true : false,
      isReoccurring: true,
    }));
    handleToggleRecurring();
  };

  return (
    <>
      <AddModal className="md:w-[500px]">
        <div className="flex justify-between items-center">
          <p>Set as recurring invoice</p>

          <div onClick={handleToggleRecurring} className="">
            <CloseIcon />
          </div>
        </div>

        <hr className="my-3 mx-[-20px]" />

        <div>
          <div className="space-y-6 py-2">
            <div>
              {repeatNonStop || (
                <div className="w-full">
                  <label
                    className="font-medium text-[14px] text-[#000000] leading-5"
                    htmlFor="End date"
                  >
                    End date
                  </label>
                  <InputComponent
                    type="date"
                    placeholder="Select date"
                    value={endDate}
                    name="issueDate"
                    handleChange={handleEndDateChange}
                    restrictFutureDates={false}
                    restrictPreviousDates={true}
                    className={`w-full border-gray-300  ${repeatNonStop && "text-gray-200"}`}
                    disabled={repeatNonStop}
                  />
                </div>
              )}
              <div className="flex gap-2 items-center mt-2">
                <input
                  type="checkbox"
                  checked={repeatNonStop}
                  onChange={(e) => setRepeatNonStop(e.target.checked)}
                  className="border-[1.2px] rounded w-4 h-4 border-gray-300"
                />
                <p className="text-[14px] font-medium text-gray-700">
                  Repeat non-stop
                </p>
              </div>
            </div>

            <div>
              <label
                className="text-[14px] text-[#000000] leading-5"
                htmlFor=""
              >
                Repeat
              </label>
              <DropdownComponent
                options={repeatArr}
                name="repeat"
                placeholder="Select interval"
                disabled={false}
                error={""}
                iconClassName="mt-[6px] md:mt-0"
                dropdownClassName="z-10 max-h-52 overflow-y-auto bg-white border border-gray-300 left-0 right-0 top-full w-full placeholder:text-[16px] text-[16px]"
                selectedValue={repeatOption}
                setSelectedValue={(option) => {
                  setRepeatOption(option);
                }}
                isSubmitted={false}
              />
            </div>

            <div>
              <label
                className="text-[14px] text-[#000000] leading-5"
                htmlFor=""
              >
                Reminder Channel
              </label>
              <DropdownComponent
                options={ChannelArr}
                placeholder="Select reminder channel"
                setSelectedValue={(option) => setReminderChannel(option)}
                disabled={false}
                error={""}
                iconClassName="mt-[6px] md:mt-0"
                dropdownClassName="z-10 max-h-52 overflow-y-auto bg-white border border-gray-300 left-0 right-0 top-full w-full placeholder:text-[16px] text-[16px]"
                selectedValue={reminderChannel}
                isSubmitted={false}
              />
            </div>
          </div>

          <hr className="my-3 mx-[-20px]" />

          <div className="flex gap-4 items-center justify-end w-full font-semibold text-[16px] h-11 mb-1">
            <button
              onClick={handleToggleRecurring}
              className="w-[84px] h-full leading-6 text-[#044E97]"
            >
              Cancel
            </button>

            {repeatNonStop ? (
              <button
                onClick={handleContinue}
                disabled={!repeatOption}
                className={`w-[98px] h-full rounded bg-[#044E97] leading-6 text-white ${!repeatOption ? "bg-gray-200 text-gray-500 " : ""}`}
              >
                Continue
              </button>
            ) : (
              <button
                onClick={handleContinue}
                disabled={!endDate || !repeatOption}
                className={`w-[98px] h-full rounded bg-[#044E97] leading-6 text-white ${!endDate || !repeatOption ? "bg-gray-200 text-gray-500 " : ""}`}
              >
                Continue
              </button>
            )}
          </div>
        </div>
      </AddModal>
    </>
  );
};

export default RecurringModal;
